<script>
import options from './ActiveRolesList.options'
export default options
</script>

<template>
  <article class="kb-active-roles-list">
    <div class="kb-active-roles-list__container-top">

      <h2 class="kb-active-roles-list__container-top-title">
        {{ getLabel('listTitleLabel') }}
      </h2>

    </div>

    <ul class="kb-active-roles-list__wrapper" v-if="rolesData?.length && confirmedRoles?.length">

      <template v-for="role, index in rolesData" :key="index">
        <li class="kb-active-roles-list__wrapper-element">
          <ActiveRoleListCard :roleCardData="role" />
        </li>
      </template>

    </ul>

    <section v-else>
      <div class="kb-active-roles-list__no-confirmed-roles-wrapper ">
        <p> {{ getLabel('noRolesText') }}</p>
      </div>

      <ul class="kb-active-roles-list__wrapper" v-if="rolesData?.length && pendingRoles?.length">

          <template v-for="role, index in pendingRoles" :key="index" >
            <li class="kb-active-roles-list__wrapper-element">
              <ActiveRoleListCard :roleCardData="role" />
            </li>
          </template>

      </ul>

    </section>

  </article>
</template>
